var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.004,
    height: 37.433,
    viewBox: "0 0 192.004 37.433",
    className: "svg dark replaced-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u898F\\u5B9A",
    transform: "translate(-129.977 -184.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2",
    transform: "translate(129.977 184.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1",
    "data-name": "\\u30D1\\u30B9 1",
    d: "M195.041,231.335h-7.293v-7.292a5.148,5.148,0,1,0-10.3,0v7.292h-7.292a5.148,5.148,0,1,0,0,10.3h7.292v7.293a5.148,5.148,0,1,0,10.3,0V241.63h7.293a5.148,5.148,0,1,0,0-10.3Z",
    transform: "translate(-165.013 -218.895)",
    fill: "#6ec8e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_1",
    "data-name": "\\u6955\\u5186\\u5F62 1",
    cx: 5.799,
    cy: 5.799,
    r: 5.799,
    transform: "translate(11.789 11.789)",
    fill: "#ffe33f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2",
    "data-name": "\\u30D1\\u30B9 2",
    d: "M609.788,222.163v-3.044h-7.317v3.044H579.387v6.73h23.085v2.67a4.561,4.561,0,0,0-3.258-1.015H592.8c-5.483,0-10.682,2.369-10.682,9.294s5.2,9.293,11.643,9.293h4.487a9.028,9.028,0,0,0,4.327-1.228v.008h.047a4.465,4.465,0,0,1-1.431,2.878l4.113,5.674a9.813,9.813,0,0,0,3.447-3.686,11.073,11.073,0,0,0,1.026-4.867h.008V228.893h6.142v-6.73Z",
    transform: "translate(-423.926 -219.035)",
    fill: "#6ec8e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_3",
    "data-name": "\\u30D1\\u30B9 3",
    d: "M307.558,237.412a10.409,10.409,0,0,0-3.6-3.766,12.719,12.719,0,0,0-6.356-1.656h-5.609v-3.1h8.495v-6.73h-8.495v-3.044h-7.317v3.044H272.761v6.73h11.911v3.1h-2.564a12.085,12.085,0,0,0-6.25,1.656,9,9,0,0,0-3.285,3.766,10.862,10.862,0,0,0-1.041,4.566,11.445,11.445,0,0,0,1.015,4.727,8.56,8.56,0,0,0,3.392,3.766,9.626,9.626,0,0,0,5.421,1.443c3.063.071,6.587-.783,8.226-2.564a9.713,9.713,0,0,0,2.4-7.051v-4.165h6.561a3.792,3.792,0,1,1,0,7.585h-4.425V252.5h4.06a10.853,10.853,0,0,0,6.169-1.629,9.885,9.885,0,0,0,3.472-3.712,11.254,11.254,0,0,0,1.041-5.074A10.028,10.028,0,0,0,307.558,237.412Z",
    transform: "translate(-231.569 -219.034)",
    fill: "#6ec8e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1",
    "data-name": "\\u9577\\u65B9\\u5F62 1",
    width: 32.969,
    height: 6.765,
    transform: "translate(82.636 12.956)",
    fill: "#ffe33f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2",
    "data-name": "\\u9577\\u65B9\\u5F62 2",
    width: 15.674,
    height: 6.765,
    transform: "translate(136.662 12.956)",
    fill: "#ffe33f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4",
    "data-name": "\\u30D1\\u30B9 4",
    d: "M418.245,228.893h-16.5v12.226a4.12,4.12,0,0,0,4.22,4.029h12.28v6.765H405.216c-5.216,0-10.789-3.793-10.789-9.79v-13.23h-9.152v-6.73h9.152v-3.044h7.317v3.044h16.5Z",
    transform: "translate(-302.639 -219.035)",
    fill: "#6ec8e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5",
    "data-name": "\\u30D1\\u30B9 5",
    d: "M526.691,278.912c0,1.689,1.9,3.6,4.1,3.6h7.958v6.765h-8.1c-5.5,0-11.3-3.025-11.3-10.362Z",
    transform: "translate(-386.415 -256.395)",
    fill: "#6ec8e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_6",
    "data-name": "\\u30D1\\u30B9 6",
    d: "M515.955,222.163H499.538l.529-3.044H492.75l-.524,3.044h-4.582v6.773h3.417l-3.954,22.978h7.264l3.991-22.978h17.593Z",
    transform: "translate(-366.267 -219.035)",
    fill: "#6ec8e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_2",
    "data-name": "\\u6955\\u5186\\u5F62 2",
    cx: 3.934,
    cy: 3.934,
    r: 3.934,
    transform: "translate(70.465 2.514)",
    fill: "#6ec8e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7",
    "data-name": "\\u30D1\\u30B9 7",
    d: "M289.043,273.585c0,3.247,1.857,3.792,2.938,3.792s3.632-.331,3.632-2.872v-4.712a12.182,12.182,0,0,0-4.45.4A3.467,3.467,0,0,0,289.043,273.585Z",
    transform: "translate(-242.511 -250.694)",
    fill: "#ffe33f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8",
    "data-name": "\\u30D1\\u30B9 8",
    d: "M619.26,268.9a3.217,3.217,0,0,1-3.207,3.207h-6.809a3.217,3.217,0,0,1-3.207-3.207h0a3.217,3.217,0,0,1,3.207-3.207h6.809a3.217,3.217,0,0,1,3.207,3.207Z",
    transform: "translate(-440.578 -248.133)",
    fill: "#ffe33f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17dc55b8c21cfd24e75ed7ada07e6bdf.svg";
export { ForwardRef as ReactComponent };